import { render, staticRenderFns } from "./Investments.vue?vue&type=template&id=63bf61a4&scoped=true&"
import script from "./Investments.vue?vue&type=script&lang=ts&"
export * from "./Investments.vue?vue&type=script&lang=ts&"
import style0 from "./Investments.vue?vue&type=style&index=0&id=63bf61a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bf61a4",
  null
  
)

export default component.exports